/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./footer-var.vue?vue&type=template&id=ad5a6206&scoped=true&"
import script from "./footer-var.vue?vue&type=script&lang=js&"
export * from "./footer-var.vue?vue&type=script&lang=js&"
import style0 from "./footer-var.vue?vue&type=style&index=0&id=ad5a6206&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5a6206",
  null
  
)

export default component.exports